export const DEFAULT_CONFIG = {
  file: {
    attributes: {
      controlsList: 'nodownload',
    },
  },
}
